import { useEffect, useState } from 'react'

import AbuseIntro from './components/AbuseIntro'
import AbuseOrderConfirmation from './components/AbuseOrderConfirmation'
import { SuspiciousAbuseStatusResponse } from './types'
import tracking from '../../shared/tracking'

const AbuseUserPage = ({ data }: { data: SuspiciousAbuseStatusResponse }) => {
  const [step, setStep] = useState<'init' | 'order'>('init')

  useEffect(() => {
    tracking.track('Discount Abuse Page Viewed', {
      case_id: data.abuseCaseId,
      page_name: 'Discount Abuse'
    })
  }, [data.abuseCaseId])

  const onConfirm = () => {
    setStep('order')
  }

  const onBack = () => {
    setStep('init')
  }

  if (step === 'init') {
    return <AbuseIntro onConfirm={onConfirm} data={data} />
  }

  if (step === 'order') {
    return (
      <AbuseOrderConfirmation
        date={data.payload.shippingDate}
        onBack={onBack}
        abuseCaseId={data.abuseCaseId}
      />
    )
  }

  return null
}

export default AbuseUserPage
